import React, { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { PATHS } from "constants/pathConstants";
import Mixpanel from "utils/mixpanel";
import HeartIcon from "assets/images/HeartIcon.svg";
import WelcomeHero from ".";

type TestingNavigationTeamHeroProps = {};

const TestingNavigationTeamHero: React.FC<TestingNavigationTeamHeroProps> = () => {
  const onActionClick = useCallback(() => {
    Mixpanel.track(`To Do Card CTA Clicked - navigation team`);
  }, [Mixpanel, PATHS]);

  return (
    <WelcomeHero
      headerIcon={HeartIcon}
      headerSubText="A member of our Navigation Team will contact you to discuss your personalized next steps."
      headerText="Contact with the Navigation Team in progress"
      onActionClick={onActionClick}
      id="contact-navigation-team-hero"
      tooltipContent={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography variant="body_sm_white">
            Based on what you've shared, we recommend you talk with a member of
            our Navigation Team to help you understand the best services and
            tests for your health and goals.
          </Typography>
        </Box>
      }
    />
  );
};

export default TestingNavigationTeamHero;
